import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16 2.257a.75.75 0 0 1 .53.22l5 5a.75.75 0 0 1 0 1.06l-2 2a.75.75 0 0 1-1.06 0l-.47-.47-3.491 3.492c.562.843.73 1.837.61 2.79-.147 1.175-.727 2.327-1.589 3.188a.75.75 0 0 1-1.06 0L9 16.067l-5.47 5.47a.75.75 0 1 1-1.06-1.06l5.47-5.47-3.47-3.47a.75.75 0 0 1 0-1.06c.861-.862 2.012-1.443 3.187-1.59.954-.119 1.948.049 2.791.611l3.491-3.491-.47-.47a.75.75 0 0 1 0-1.06l2-2a.75.75 0 0 1 .531-.22m-.94 2.75.47.47a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0c-.557-.557-1.312-.763-2.127-.661a4 4 0 0 0-1.734.68l6.842 6.841a4 4 0 0 0 .68-1.733c.102-.815-.104-1.57-.661-2.127a.75.75 0 0 1 0-1.06l4.5-4.5a.75.75 0 0 1 1.06 0l.47.47.94-.94L16 4.067z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }